"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingsAndReviewsCount = exports.StarRating = void 0;
var StarRating_1 = require("./StarRating");
Object.defineProperty(exports, "StarRating", { enumerable: true, get: function () { return StarRating_1.StarRating; } });
var RatingsAndReviewsCount_1 = require("./RatingsAndReviewsCount");
Object.defineProperty(exports, "RatingsAndReviewsCount", { enumerable: true, get: function () { return RatingsAndReviewsCount_1.RatingsAndReviewsCount; } });
//# sourceMappingURL=index.js.map